let _hooks;
export const setupHooks = (_) => {
    _hooks = _;
};
const lazyHook = (name) => (...args) => _hooks[name](...args);
export const useState = lazyHook('useState');
export const useEffect = lazyHook('useEffect');
export const useLayoutEffect = lazyHook('useLayoutEffect');
export const useCallback = lazyHook('useCallback');
export const useMemo = lazyHook('useMemo');
export const useRef = lazyHook('useRef');
